import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Divider, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { IconComponent } from '@shared/components/IconComponent';
import Popup from '@shared/components/Popup';
import { SUPPORT_NUMBERS } from '../appbar/constants';
import { useState } from 'react';
import { config } from '@services/context';

export const HelpMenuPopup = props => {
  const [isPhoneNumbersOpen, setIsPhoneNumbersOpen] = useState(false);

  const handlePhoneNumberClick = (phoneNumber: string) => {
    window.open(`tel:${phoneNumber}`, '_blank');
    props.onClose();
  };
  const handleEmailClick = () => {
    window.open('mailto:support@flux.live', '_blank');
    props.onClose();
  };

  return (
    <Popup offset={[0, 20]} arrow {...props}>
      <Stack direction="column" style={{ marginTop: 0, marginBottom: 0 }}>
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={handleEmailClick}>
              <ListItemIcon style={{ fontSize: 20 }}>
                <IconComponent name="ri-mail-line" />
              </ListItemIcon>
              <ListItemText primary="Email" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => setIsPhoneNumbersOpen(!isPhoneNumbersOpen)}>
              <ListItemIcon style={{ fontSize: 20 }}>
                <IconComponent name="ri-phone-line" />
              </ListItemIcon>
              <ListItemText primary="Phone Numbers" />
              <IconComponent name={isPhoneNumbersOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} iconStyle={{ fontSize: 16 }} />
            </ListItemButton>
          </ListItem>

          <Collapse in={isPhoneNumbersOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {SUPPORT_NUMBERS.map(({ countryCode, phoneNumber }) => (
                <ListItem key={phoneNumber} disablePadding>
                  <ListItemButton sx={{ pl: 4 }} onClick={() => handlePhoneNumberClick(phoneNumber)}>
                    <ListItemIcon style={{ fontSize: 16 }}>
                      <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{countryCode}</span>
                    </ListItemIcon>
                    <ListItemText primary={phoneNumber} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </List>
      </Stack>
    </Popup>
  );
};
